import { QFilterGeneric } from './QFilterGeneric'

export class QFilterDateField extends QFilterGeneric {
  name="date_fields"
  class_name = "QFilterDateField";
  api_name = 'date_fields';
  chip_component = 'ChipDateField';
  
  serialize(qfilters) {
    return encodeURIComponent(this.value);
  }

}
